import React from "react"
import PropTypes from "prop-types"
import CompleteIcon from "./CompleteIcon"
import ExpiredIcon from "./ExpiredIcon"
import IncompleteIcon from "./IncompleteIcon"
import LockedIcon from "./LockedIcon"
import NotStartedIcon from "./NotStartedIcon"
import RejectedIcon from "./RejectedIcon"
import PendingApprovalIcon from "./PendingApprovalIcon"
import StartedIcon from "./StartedIcon"
import VerifiedIcon from "./VerifiedIcon"

const icons = {
  expired: ExpiredIcon,
  rejected: RejectedIcon,
  not_started: NotStartedIcon,
  verified: VerifiedIcon,
  pending_approval: PendingApprovalIcon,
  complete: CompleteIcon,
  started: StartedIcon,
  incomplete: IncompleteIcon,
  locked: LockedIcon
}

const StatusIconWrapper = ({ status, size, color }) => {
  const Icon = icons[status]
  return <Icon size={size} color={color} />
}

StatusIconWrapper.propTypes = {
  status: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.string,
  color: PropTypes.string
}

StatusIconWrapper.defaultProps = {
  status: "not_started",
  size: "1x",
  color: "#ffffff"
}

export default StatusIconWrapper
